module.exports = __webpack_public_path__ + "img/pflege.f2c81fb4.svg";